import { Type, Transform } from 'class-transformer';
import {
  IsInt,
  IsNumber,
  IsIn,
  IsArray,
  IsString,
  IsDateString,
  IsUUID,
  IsNotEmpty,
  ValidateNested,
  IsOptional,
  IsBoolean,
} from 'class-validator';
import { injectable } from 'inversify';

import { HttpService } from '@vk-hr-tek/core/http';
import {
  FiltersResponse,
  Filter,
  FilterService,
  FilterType,
} from '@vk-hr-tek/core/filter';
import { ValidationService } from '@vk-hr-tek/core/validation';
import { UnmarshallerService } from '@vk-hr-tek/core/unmarshaller';
import { QueryService } from '@vk-hr-tek/core/query';

export class GetAutoInviteSettingsParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class ConfigureAutoInviteSettingsParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class RevokeCommunityMemberRoleParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class SetCommunityMemberRoleParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class getCommunityParticipantsListingAvailableFiltersParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class getCommunityParticipantsEditAvailableFiltersParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class getCommunityParticipantsParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class AllCompaniesInCommunityParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class getCommunityUserInvitersParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class GetCommunityInviteStatusParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class RemoveCommunityInvitesParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class InviteUsersInCommunityParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class getAvailableUsersForCommunityParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class getUserCommunityPermissionsParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class GetCommunityCompaniesFilterOptionsByScopeParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class RejectCommunityInvitesParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class CommunityUserSettingsParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class RejectCommunityInviteParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;

  @IsUUID()
  @IsNotEmpty()
  invite_id: string;
}

export class AcceptCommunityInviteParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;

  @IsUUID()
  @IsNotEmpty()
  invite_id: string;
}

export class RejectCommunityJoinRequestsParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class CancelCommunityJoinRequestParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;

  @IsUUID()
  @IsNotEmpty()
  join_request_id: string;
}

export class AcceptCommunityJoinRequestsParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class RemoveCommunityJoinRequestsParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class CreateCommunityJoinRequestParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class UnsubscribeFromCommunityParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class SubscribeToCommunityParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class AssignCommunityOwnerParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class RemoveCommunityMembersParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class GetCommunityMembersParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class ApproveSuggestedPostParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;

  @IsUUID()
  @IsNotEmpty()
  post_id: string;
}

export class DeclineSuggestedPostParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;

  @IsUUID()
  @IsNotEmpty()
  post_id: string;
}

export class UnpinCommunityPostParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;

  @IsUUID()
  @IsNotEmpty()
  post_id: string;
}

export class PinCommunityPostParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;

  @IsUUID()
  @IsNotEmpty()
  post_id: string;
}

export class DeleteCommunityPostParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;

  @IsUUID()
  @IsNotEmpty()
  post_id: string;
}

export class UpdateCommunityPostParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;

  @IsUUID()
  @IsNotEmpty()
  post_id: string;
}

export class GetCommunityPostParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;

  @IsUUID()
  @IsNotEmpty()
  post_id: string;
}

export class GetAccountTagsFilterOptionsParams {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;
}

export class SuggestCommunityPostParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class CreateCommunityPostParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class GetCommunityFeedParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class DeleteCommunityParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class UpdateCommunityParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class GetCommunityParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;
}

export class MarkPostAsReadParams {
  @IsUUID()
  @IsNotEmpty()
  community_id: string;

  @IsUUID()
  @IsNotEmpty()
  post_id: string;
}

export class GetCommunitiesUnitChildrenParams {
  @IsUUID()
  @IsNotEmpty()
  company_id: string;

  @IsUUID()
  @IsNotEmpty()
  unit_id: string;
}

export class GetCommunitiesCompanyUnitsTreeParams {
  @IsUUID()
  @IsNotEmpty()
  company_id: string;
}

export class GetCommunitiesCompanyUnitTypesParams {
  @IsUUID()
  @IsNotEmpty()
  company_id: string;
}

export class CommunityCategoryTitlesFilterOptionsQuery {
  @IsString({ each: true })
  @IsArray()
  @IsOptional()
  values?: string[];

  @IsString()
  @IsOptional()
  query?: string;

  @IsNumber()
  @IsOptional()
  limit?: number;

  @IsNumber()
  @IsOptional()
  offset?: number;
}

export class GetCommunityParticipantsRolesQuery {
  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  roles?: string[];

  @IsString()
  @IsOptional()
  query?: string;

  @IsNumber()
  @IsOptional()
  limit?: number;

  @IsNumber()
  @IsOptional()
  offset?: number;
}

export class GetCommunityInviteStatusQuery {
  @IsUUID()
  @IsNotEmpty()
  operation_id: string;
}

export class getAvailableUsersForCommunityQuery {
  @IsString()
  @IsOptional()
  query?: string;

  @IsInt()
  @IsOptional()
  limit?: number;

  @IsInt()
  @IsOptional()
  offset?: number;
}

export class GetCommunitiesRecommendationsQuery {
  @IsNumber()
  @IsOptional()
  limit?: number;
}

export class GetCommunitiesSubscriptionsQuery {
  @IsNumber()
  @IsOptional()
  limit?: number;
}

export class GetCommunityCompaniesFilterOptionsByScopeQuery {
  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  ids?: string[];

  @IsString()
  @IsOptional()
  query?: string;

  @IsNumber()
  @IsOptional()
  limit?: number;

  @IsNumber()
  @IsOptional()
  offset?: number;
}

export class GetCommunityCompaniesFilterOptionsQuery {
  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  ids?: string[];

  @IsString()
  @IsOptional()
  query?: string;

  @IsNumber()
  @IsOptional()
  limit?: number;

  @IsNumber()
  @IsOptional()
  offset?: number;
}

export class GetCommunityMembersQuery {
  @IsString()
  @IsOptional()
  query?: string;

  @IsNumber()
  @IsOptional()
  limit?: number;

  @IsNumber()
  @IsOptional()
  offset?: number;

  @IsBoolean()
  @IsOptional()
  exclude_me?: boolean;
}

export class GetAccountTagsFilterOptionsQuery {
  @IsString({ each: true })
  @IsArray()
  @IsOptional()
  values?: string[];

  @IsString()
  @IsOptional()
  query?: string;

  @IsNumber()
  @IsOptional()
  limit?: number;

  @IsNumber()
  @IsOptional()
  offset?: number;
}

export class GetCommunitiesTagsFilterOptionsQuery {
  @IsString({ each: true })
  @IsArray()
  @IsOptional()
  values?: string[];

  @IsString()
  @IsOptional()
  query?: string;

  @IsNumber()
  @IsOptional()
  limit?: number;

  @IsNumber()
  @IsOptional()
  offset?: number;
}

export class GetCommunitiesFilterOptionsQuery {
  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  ids?: string[];

  @IsString()
  @IsOptional()
  query?: string;

  @IsNumber()
  @IsOptional()
  limit?: number;

  @IsNumber()
  @IsOptional()
  offset?: number;
}

export type UnitType = string;

export class GetUnitsOptionsQuery {
  @IsUUID()
  @IsOptional()
  company_id?: string;

  @IsUUID()
  @IsOptional()
  community_id?: string;

  @IsIn(['operational', 'legal'])
  @IsString()
  @IsOptional()
  unit_type?: 'operational' | 'legal';

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  id?: string[];

  @IsString()
  @IsOptional()
  query?: string;

  @IsBoolean()
  @IsOptional()
  query_include_root?: boolean;

  @IsNumber()
  @IsOptional()
  limit?: number;

  @IsNumber()
  @IsOptional()
  offset?: number;
}

export class GetCommunitiesUnitChildrenQuery {
  @IsUUID()
  @IsOptional()
  community_id?: string;
}

export class GetCommunitiesCompanyUnitsTreeQuery {
  @IsUUID()
  @IsOptional()
  community_id?: string;

  @IsIn(['operational', 'legal'])
  @IsString()
  @IsOptional()
  unit_type?: 'operational' | 'legal';

  @IsUUID()
  @IsOptional()
  unit_id?: string;
}

export class GetCommunitiesCompanyUnitTypesQuery {
  @IsUUID()
  @IsOptional()
  community_id?: string;
}

export class GetCommunityCompaniesQuery {
  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  account_ids?: string[];

  @IsUUID()
  @IsOptional()
  community_id?: string;
}

export class GetCommunityAccountsQuery {
  @IsUUID()
  @IsOptional()
  community_id?: string;
}

export class FilterSelectBadge {
  @IsString()
  @IsNotEmpty()
  title: string;

  @IsString()
  @IsOptional()
  description?: string;

  @IsIn(['blue', 'velvet', 'red'])
  @IsString()
  @IsOptional()
  color?: 'blue' | 'velvet' | 'red';

  @IsIn(['left', 'bottom'])
  @IsString()
  @IsOptional()
  position?: 'left' | 'bottom';
}

export class FilterSelectOption {
  @IsString()
  @IsNotEmpty()
  value: string;

  @IsString()
  @IsNotEmpty()
  label: string;

  @IsIn(['item'])
  @IsString()
  @IsOptional()
  type?: 'item';

  @ValidateNested()
  @Type(() => FilterSelectBadge)
  @IsOptional()
  badge?: FilterSelectBadge;
}

export type CommunityCategoryTitlesFilterOptionsResponse = FilterSelectOption[];

export type CommunityJoinMode = string;

export class CompaniesGroup {
  @IsIn(['auto_join', 'require_confirmation'])
  @IsString()
  @IsNotEmpty()
  join_mode: 'auto_join' | 'require_confirmation';

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  company_ids?: string[];
}

export class AutoInviteCommunitySettingsResponse {
  @IsIn(['all', 'custom', 'none'])
  @IsString()
  @IsNotEmpty()
  mode: 'all' | 'custom' | 'none';

  @IsIn(['auto_join', 'require_confirmation'])
  @IsString()
  @IsOptional()
  join_mode?: 'auto_join' | 'require_confirmation';

  @ValidateNested({ each: true })
  @Type(() => CompaniesGroup)
  @IsArray()
  @IsOptional()
  company_groups?: CompaniesGroup[];
}

export type CommunityAssignableRole = string;

export class CommunityAssignableRolesResponse {
  @IsIn(['admin', 'moderator', 'editor'], { each: true })
  @IsString({ each: true })
  @IsArray()
  @IsNotEmpty()
  roles: ('admin' | 'moderator' | 'editor')[];
}

export type CommunityParticipantsRolesFilterOptionsResponse =
  FilterSelectOption[];

export class FilterTimeRange {
  @IsString()
  @IsNotEmpty()
  key: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['timerange'])
  @IsString()
  @IsNotEmpty()
  type: 'timerange';

  @IsString()
  @IsNotEmpty()
  placeholder: string;

  @IsIn(['till_now', 'any', 'from_now'])
  @IsString()
  @IsNotEmpty()
  allow_dates: 'till_now' | 'any' | 'from_now';

  @IsBoolean()
  @IsOptional()
  hidden?: boolean;
}

export class FilterBool {
  @IsString()
  @IsNotEmpty()
  key: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['bool'])
  @IsString()
  @IsNotEmpty()
  type: 'bool';

  @IsBoolean()
  @IsOptional()
  hidden?: boolean;

  @IsString()
  @IsOptional()
  tooltip?: string;
}

export class FilterMultipleSearch {
  @IsString()
  @IsNotEmpty()
  key: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['multiple-search'])
  @IsString()
  @IsNotEmpty()
  type: 'multiple-search';

  @IsString()
  @IsNotEmpty()
  url: string;

  @IsString()
  @IsNotEmpty()
  placeholder: string;

  @IsBoolean()
  @IsOptional()
  hidden?: boolean;
}

export class FilterSearch {
  @IsString()
  @IsNotEmpty()
  key: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['search'])
  @IsString()
  @IsNotEmpty()
  type: 'search';

  @IsString()
  @IsNotEmpty()
  url: string;

  @IsString()
  @IsNotEmpty()
  placeholder: string;

  @IsBoolean()
  @IsOptional()
  disable_if_one_option?: boolean;

  @IsBoolean()
  @IsOptional()
  hidden?: boolean;
}

export class FilterText {
  @IsString()
  @IsNotEmpty()
  key: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['text'])
  @IsString()
  @IsNotEmpty()
  type: 'text';

  @IsString()
  @IsNotEmpty()
  placeholder: string;

  @IsBoolean()
  @IsOptional()
  hidden?: boolean;
}

export class FilterMultiple {
  @IsString()
  @IsNotEmpty()
  key: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['multiple'])
  @IsString()
  @IsNotEmpty()
  type: 'multiple';

  @ValidateNested({ each: true })
  @Type(() => FilterSelectOption)
  @IsArray()
  @IsNotEmpty()
  options: FilterSelectOption[];

  @IsString()
  @IsNotEmpty()
  placeholder: string;

  @IsBoolean()
  @IsOptional()
  disable_if_one_option?: boolean;

  @IsBoolean()
  @IsOptional()
  hidden?: boolean;

  @IsBoolean()
  @IsOptional()
  autocomplete?: boolean;

  @IsBoolean()
  @IsOptional()
  clearable?: boolean;
}

export class FilterSelect {
  @IsString()
  @IsNotEmpty()
  key: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['select'])
  @IsString()
  @IsNotEmpty()
  type: 'select';

  @ValidateNested({ each: true })
  @Type(() => FilterSelectOption)
  @IsArray()
  @IsNotEmpty()
  options: FilterSelectOption[];

  @IsString()
  @IsNotEmpty()
  placeholder: string;

  @IsBoolean()
  @IsOptional()
  autocomplete?: boolean;

  @IsBoolean()
  @IsOptional()
  disable_if_one_option?: boolean;

  @IsBoolean()
  @IsOptional()
  hidden?: boolean;
}

export class CommunityParticipantsListingAvailableFilters {
  @IsArray()
  @IsNotEmpty()
  filters: (
    | FilterSelect
    | FilterMultiple
    | FilterText
    | FilterSearch
    | FilterMultipleSearch
    | FilterBool
    | FilterTimeRange
  )[];
}

export class CommunityParticipantsEditAvailableFilters {
  @IsArray()
  @IsNotEmpty()
  filters: (
    | FilterSelect
    | FilterMultiple
    | FilterText
    | FilterSearch
    | FilterMultipleSearch
    | FilterBool
    | FilterTimeRange
  )[];
}

export type ParticipantStatus = string;

export type CommunityMemberRole = string;

export class ParticipantActions {
  @IsBoolean()
  @IsNotEmpty()
  accept_request: boolean;

  @IsBoolean()
  @IsNotEmpty()
  reject_request: boolean;

  @IsBoolean()
  @IsNotEmpty()
  revoke_invite: boolean;

  @IsBoolean()
  @IsNotEmpty()
  exclude_from_community: boolean;

  @IsBoolean()
  @IsNotEmpty()
  exclude_and_assign_new_owner: boolean;

  @IsBoolean()
  @IsNotEmpty()
  assign_owner: boolean;

  @IsBoolean()
  @IsNotEmpty()
  reassign_owner: boolean;

  @IsBoolean()
  @IsNotEmpty()
  reassign_owner_by_owner: boolean;

  @IsBoolean()
  @IsNotEmpty()
  set_role: boolean;

  @IsBoolean()
  @IsNotEmpty()
  revoke_role: boolean;

  @IsBoolean()
  @IsNotEmpty()
  leave_community: boolean;

  @IsBoolean()
  @IsNotEmpty()
  unsubscribe: boolean;
}

export type CryptoProPluginOpenType = string;

export class CompanyItem {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsOptional()
  tsp_url?: string;

  @IsIn(['capi', 'cades'])
  @IsString()
  @IsOptional()
  crypto_pro_plugin_open_type?: 'capi' | 'cades';

  @IsIn(['api', 'browser_plugin'])
  @IsString()
  @IsOptional()
  hash_source?: 'api' | 'browser_plugin';
}

export class SocialUserCompanyPosition {
  @ValidateNested()
  @Type(() => CompanyItem)
  @IsNotEmpty()
  company: CompanyItem;

  @IsString()
  @IsNotEmpty()
  position: string;

  @IsString()
  @IsOptional()
  unit_name?: string;
}

export class SocialUser {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] })
  @IsString()
  @IsNotEmpty()
  first_name: string;

  @Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] })
  @IsString()
  @IsNotEmpty()
  second_name: string;

  @Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] })
  @IsString()
  @IsNotEmpty()
  middle_name: string;

  @IsString()
  @IsOptional()
  logo?: string;

  @ValidateNested({ each: true })
  @Type(() => SocialUserCompanyPosition)
  @IsArray()
  @IsOptional()
  companies?: SocialUserCompanyPosition[];
}

export class CommunityParticipant {
  @ValidateNested()
  @Type(() => SocialUser)
  @IsNotEmpty()
  user: SocialUser;

  @ValidateNested()
  @Type(() => ParticipantActions)
  @IsNotEmpty()
  actions: ParticipantActions;

  @IsIn(['owner', 'subscriber', 'admin', 'moderator', 'editor'])
  @IsString()
  @IsNotEmpty()
  role: 'owner' | 'subscriber' | 'admin' | 'moderator' | 'editor';

  @IsUUID()
  @IsOptional()
  join_request_id?: string;
}

export class CommunityParticipantsResponse {
  @ValidateNested()
  @Type(() => SocialUser)
  @IsOptional()
  owner?: SocialUser;

  @ValidateNested({ each: true })
  @Type(() => CommunityParticipant)
  @IsArray()
  @IsNotEmpty()
  participants: CommunityParticipant[];

  @IsIn(['member', 'admin', 'invited', 'join_request'])
  @IsString()
  @IsNotEmpty()
  status: 'member' | 'admin' | 'invited' | 'join_request';

  @IsInt()
  @IsNotEmpty()
  member_count: number;

  @IsInt()
  @IsNotEmpty()
  admin_count: number;

  @IsInt()
  @IsNotEmpty()
  invited_count: number;

  @IsInt()
  @IsNotEmpty()
  join_request_count: number;

  @IsInt()
  @IsNotEmpty()
  total_count: number;
}

export class UnitItem {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['operational', 'legal'])
  @IsString()
  @IsNotEmpty()
  type: 'operational' | 'legal';
}

export class CommunityCompanyWithUnits {
  @ValidateNested()
  @Type(() => CompanyItem)
  @IsNotEmpty()
  company: CompanyItem;

  @ValidateNested({ each: true })
  @Type(() => UnitItem)
  @IsArray()
  @IsNotEmpty()
  units: UnitItem[];
}

export class AllCompaniesInCommunityResponse {
  @ValidateNested({ each: true })
  @Type(() => CommunityCompanyWithUnits)
  @IsArray()
  @IsNotEmpty()
  companies: CommunityCompanyWithUnits[];
}

export class CommunityUserInvitersResponse {
  @ValidateNested({ each: true })
  @Type(() => SocialUser)
  @IsArray()
  @IsNotEmpty()
  users: SocialUser[];
}

export class InviteUsersStatusInCommunityResponse {
  @IsInt()
  @IsNotEmpty()
  added_count: number;

  @IsInt()
  @IsNotEmpty()
  failed_count: number;

  @IsIn(['new', 'progress', 'success', 'error'])
  @IsString()
  @IsNotEmpty()
  status: 'new' | 'progress' | 'success' | 'error';
}

export class InviteUsersInCommunityResponse {
  @IsInt()
  @IsNotEmpty()
  added_count: number;

  @IsInt()
  @IsNotEmpty()
  failed_count: number;

  @IsUUID()
  @IsNotEmpty()
  operation_id: string;
}

export class CommunityAvailableUserToInvite {
  @ValidateNested()
  @Type(() => SocialUser)
  @IsNotEmpty()
  user: SocialUser;

  @IsBoolean()
  @IsNotEmpty()
  is_subscriber: boolean;
}

export class CommunityAvailableUsersToInviteResponse {
  @ValidateNested({ each: true })
  @Type(() => CommunityAvailableUserToInvite)
  @IsArray()
  @IsNotEmpty()
  users: CommunityAvailableUserToInvite[];

  @IsBoolean()
  @IsNotEmpty()
  hasMore: boolean;
}

export class CommunityUserPermissionsResponse {
  @IsBoolean()
  @IsNotEmpty()
  is_member: boolean;

  @IsBoolean()
  @IsNotEmpty()
  edit_community: boolean;

  @IsBoolean()
  @IsNotEmpty()
  show_participants: boolean;

  @IsBoolean()
  @IsNotEmpty()
  manage_participants: boolean;

  @IsBoolean()
  @IsNotEmpty()
  unsubscribe: boolean;

  @IsBoolean()
  @IsNotEmpty()
  delete_community: boolean;

  @IsBoolean()
  @IsNotEmpty()
  accept_request: boolean;

  @IsBoolean()
  @IsNotEmpty()
  reject_request: boolean;

  @IsBoolean()
  @IsNotEmpty()
  send_request: boolean;

  @IsBoolean()
  @IsNotEmpty()
  cancel_request: boolean;

  @IsBoolean()
  @IsNotEmpty()
  invite_user: boolean;

  @IsBoolean()
  @IsNotEmpty()
  bulk_invite: boolean;

  @IsBoolean()
  @IsNotEmpty()
  auto_invite: boolean;

  @IsBoolean()
  @IsNotEmpty()
  leave_community: boolean;

  @IsBoolean()
  @IsNotEmpty()
  create_post: boolean;

  @IsBoolean()
  @IsNotEmpty()
  suggest_post: boolean;

  @IsBoolean()
  @IsNotEmpty()
  manage_post_admin_settings: boolean;

  @IsBoolean()
  @IsNotEmpty()
  show_feed: boolean;

  @IsBoolean()
  @IsNotEmpty()
  hide_in_common_feed: boolean;
}

export class AccountItem {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class CommunityJoinRequest {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsDateString()
  @IsNotEmpty()
  requested_at: string;
}

export class CommunityInvite {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsDateString()
  @IsNotEmpty()
  invited_at: string;
}

export class CommunityMembershipInfo {
  @IsIn(['owner', 'subscriber', 'admin', 'moderator', 'editor'])
  @IsString()
  @IsOptional()
  role?: 'owner' | 'subscriber' | 'admin' | 'moderator' | 'editor';

  @ValidateNested({ each: true })
  @Type(() => CommunityInvite)
  @IsArray()
  @IsOptional()
  invites?: CommunityInvite[];

  @ValidateNested({ each: true })
  @Type(() => CommunityJoinRequest)
  @IsArray()
  @IsOptional()
  join_requests?: CommunityJoinRequest[];
}

export class SocialEntityCategory {
  @IsString()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['gray', 'darkgray', 'green', 'orange', 'purple', 'blue', 'red'])
  @IsString()
  @IsNotEmpty()
  color: 'gray' | 'darkgray' | 'green' | 'orange' | 'purple' | 'blue' | 'red';
}

export type CommunityType = string;

export type Slug = string;

export class CommunityListItem {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsUUID()
  @IsOptional()
  avatar_attachment_id?: string;

  @IsString()
  @IsNotEmpty()
  title: string;

  @IsString()
  @IsNotEmpty()
  slug: string;

  @IsIn(['public', 'private', 'hidden'])
  @IsString()
  @IsNotEmpty()
  community_type: 'public' | 'private' | 'hidden';

  @ValidateNested()
  @Type(() => SocialEntityCategory)
  @IsNotEmpty()
  category: SocialEntityCategory;

  @IsInt()
  @IsNotEmpty()
  participants_count: number;

  @ValidateNested()
  @Type(() => CommunityMembershipInfo)
  @IsNotEmpty()
  membership_info: CommunityMembershipInfo;

  @ValidateNested()
  @Type(() => AccountItem)
  @IsNotEmpty()
  account: AccountItem;
}

export class CommunitiesShortListResponse {
  @ValidateNested({ each: true })
  @Type(() => CommunityListItem)
  @IsArray()
  @IsNotEmpty()
  communities: CommunityListItem[];
}

export class AvailableFilters {
  @IsArray()
  @IsNotEmpty()
  filters: (
    | FilterSelect
    | FilterMultiple
    | FilterText
    | FilterSearch
    | FilterMultipleSearch
    | FilterBool
    | FilterTimeRange
  )[];
}

export class CommunityInfo {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @ValidateNested()
  @Type(() => AccountItem)
  @IsNotEmpty()
  account: AccountItem;

  @IsString()
  @IsNotEmpty()
  title: string;

  @IsString()
  @IsNotEmpty()
  slug: string;

  @IsUUID()
  @IsOptional()
  avatar_attachment_id?: string;

  @IsIn(['public', 'private', 'hidden'])
  @IsString()
  @IsNotEmpty()
  community_type: 'public' | 'private' | 'hidden';

  @IsBoolean()
  @IsNotEmpty()
  comments_enabled: boolean;

  @IsBoolean()
  @IsNotEmpty()
  reactions_enabled: boolean;
}

export class PostModeration {
  @ValidateNested()
  @Type(() => SocialUser)
  @IsNotEmpty()
  moderator: SocialUser;

  @IsString()
  @IsNotEmpty()
  comment: string;

  @IsDateString()
  @IsNotEmpty()
  created_at: string;
}

export class PostModerationInfo {
  @IsIn(['moderation', 'declined'])
  @IsString()
  @IsNotEmpty()
  status: 'moderation' | 'declined';

  @ValidateNested({ each: true })
  @Type(() => PostModeration)
  @IsArray()
  @IsNotEmpty()
  moderation_list: PostModeration[];
}

export class PostUserActions {
  @IsBoolean()
  @IsOptional()
  edit?: boolean;

  @IsBoolean()
  @IsOptional()
  check_suggested?: boolean;

  @IsBoolean()
  @IsOptional()
  decline_suggested?: boolean;

  @IsBoolean()
  @IsOptional()
  delete?: boolean;

  @IsBoolean()
  @IsOptional()
  pin?: boolean;

  @IsBoolean()
  @IsOptional()
  favorites?: boolean;
}

export class WidgetsInPost {
  @IsString()
  @IsNotEmpty()
  widget_name: string;

  @IsIn(['posts_feed'])
  @IsString()
  @IsNotEmpty()
  widget_type: 'posts_feed';

  @IsString()
  @IsOptional()
  account_name?: string;

  @IsString()
  @IsOptional()
  company_name?: string;
}

export class Reaction {
  @IsString()
  @IsNotEmpty()
  type: string;
}

export class ReactionItem {
  @ValidateNested()
  @Type(() => Reaction)
  @IsNotEmpty()
  reaction: Reaction;

  @IsInt()
  @IsNotEmpty()
  count: number;
}

export class EntityReactions {
  @ValidateNested({ each: true })
  @Type(() => ReactionItem)
  @IsArray()
  @IsNotEmpty()
  data: ReactionItem[];

  @IsString()
  @IsOptional()
  active_reaction_type?: string;
}

export class CommunityPostAdminSettings {
  @IsIn(['admin'])
  @IsString()
  @IsNotEmpty()
  type: 'admin';

  @IsBoolean()
  @IsNotEmpty()
  comments_enabled: boolean;

  @IsBoolean()
  @IsNotEmpty()
  reactions_enabled: boolean;

  @IsBoolean()
  @IsNotEmpty()
  hide_author: boolean;
}

export class CommunityPostSettings {
  @IsIn(['common'])
  @IsString()
  @IsNotEmpty()
  type: 'common';

  @IsBoolean()
  @IsNotEmpty()
  comments_enabled: boolean;

  @IsBoolean()
  @IsNotEmpty()
  reactions_enabled: boolean;
}

export class ContentSurveyActions {
  @IsBoolean()
  @IsNotEmpty()
  results: boolean;

  @IsBoolean()
  @IsNotEmpty()
  report: boolean;
}

export class UserAnswerMultipleTextChoice {
  @IsIn(['multiple_text_choice'])
  @IsString()
  @IsNotEmpty()
  answer_type: 'multiple_text_choice';

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsNotEmpty()
  selected_options: string[];
}

export class UserAnswerSingleTextChoice {
  @IsIn(['single_text_choice'])
  @IsString()
  @IsNotEmpty()
  answer_type: 'single_text_choice';

  @IsUUID()
  @IsOptional()
  selected_option?: string;
}

export class UserAnswerFreeText {
  @IsIn(['free_text'])
  @IsString()
  @IsNotEmpty()
  answer_type: 'free_text';

  @IsString()
  @IsNotEmpty()
  text: string;
}

export class ContentSurveyUserAnswerOneOf {
  @IsNotEmpty()
  object:
    | UserAnswerFreeText
    | UserAnswerSingleTextChoice
    | UserAnswerMultipleTextChoice;
}

export class ContentSurveyUserAnswer {
  @IsUUID()
  @IsNotEmpty()
  question_id: string;

  @ValidateNested()
  @Type(() => ContentSurveyUserAnswerOneOf)
  @IsOptional()
  user_answer?: ContentSurveyUserAnswerOneOf;
}

export class ContentSurveyUserPassing {
  @ValidateNested({ each: true })
  @Type(() => ContentSurveyUserAnswer)
  @IsArray()
  @IsNotEmpty()
  answers: ContentSurveyUserAnswer[];

  @IsInt()
  @IsNotEmpty()
  version: number;
}

export class FreeTextAnswerSettings {
  @IsIn(['free_text'])
  @IsString()
  @IsNotEmpty()
  answer_type: 'free_text';

  @IsInt()
  @IsOptional()
  max_length?: number;

  @IsInt()
  @IsOptional()
  min_length?: number;
}

export class TextChoiceAnswerOption {
  @IsUUID()
  @IsOptional()
  id?: string;

  @IsIn(['text'])
  @IsString()
  @IsNotEmpty()
  type: 'text';

  @IsString()
  @IsNotEmpty()
  text_value: string;
}

export class MultipleTextChoiceAnswerSettings {
  @IsIn(['multiple_text_choice'])
  @IsString()
  @IsNotEmpty()
  answer_type: 'multiple_text_choice';

  @ValidateNested({ each: true })
  @Type(() => TextChoiceAnswerOption)
  @IsArray()
  @IsNotEmpty()
  answer_options: TextChoiceAnswerOption[];
}

export class SingleTextChoiceAnswerSettings {
  @IsIn(['single_text_choice'])
  @IsString()
  @IsNotEmpty()
  answer_type: 'single_text_choice';

  @ValidateNested({ each: true })
  @Type(() => TextChoiceAnswerOption)
  @IsArray()
  @IsNotEmpty()
  answer_options: TextChoiceAnswerOption[];
}

export class ContentSurveyQuestionAnswerSettings {
  @IsNotEmpty()
  object:
    | SingleTextChoiceAnswerSettings
    | MultipleTextChoiceAnswerSettings
    | FreeTextAnswerSettings;
}

export type AttachmentItemType = string;

export class AttachmentItem {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsIn(['image', 'file'])
  @IsString()
  @IsNotEmpty()
  type: 'image' | 'file';
}

export class BaseContentItem {
  @IsString()
  @IsOptional()
  data?: string;

  @ValidateNested({ each: true })
  @Type(() => AttachmentItem)
  @IsArray()
  @IsOptional()
  attachments?: AttachmentItem[];
}

export class ContentSurveyQuestion {
  @IsUUID()
  @IsOptional()
  id?: string;

  @ValidateNested()
  @Type(() => BaseContentItem)
  @IsNotEmpty()
  content: BaseContentItem;

  @ValidateNested()
  @Type(() => ContentSurveyQuestionAnswerSettings)
  @IsNotEmpty()
  answer_settings: ContentSurveyQuestionAnswerSettings;
}

export class ContentSurvey {
  @IsUUID()
  @IsOptional()
  id?: string;

  @IsString()
  @IsNotEmpty()
  title: string;

  @IsBoolean()
  @IsNotEmpty()
  anonymous: boolean;

  @IsBoolean()
  @IsNotEmpty()
  show_result: boolean;

  @IsDateString()
  @IsOptional()
  completed_at?: string;

  @IsInt()
  @IsNotEmpty()
  version: number;

  @ValidateNested({ each: true })
  @Type(() => ContentSurveyQuestion)
  @IsArray()
  @IsNotEmpty()
  questions: ContentSurveyQuestion[];
}

export class ContentSurveyItem {
  @ValidateNested()
  @Type(() => ContentSurvey)
  @IsNotEmpty()
  survey: ContentSurvey;

  @IsInt()
  @IsOptional()
  passes_num?: number;

  @ValidateNested()
  @Type(() => ContentSurveyUserPassing)
  @IsOptional()
  passing?: ContentSurveyUserPassing;

  @ValidateNested()
  @Type(() => ContentSurveyActions)
  @IsOptional()
  actions?: ContentSurveyActions;
}

export class MentionItem {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsIn(['user', 'unit'])
  @IsString()
  @IsNotEmpty()
  type: 'user' | 'unit';
}

export class ContentItem {
  @IsString()
  @IsOptional()
  data?: string;

  @ValidateNested({ each: true })
  @Type(() => AttachmentItem)
  @IsArray()
  @IsOptional()
  attachments?: AttachmentItem[];

  @ValidateNested({ each: true })
  @Type(() => MentionItem)
  @IsArray()
  @IsOptional()
  mentions?: MentionItem[];

  @ValidateNested({ each: true })
  @Type(() => ContentSurveyItem)
  @IsArray()
  @IsOptional()
  surveys?: ContentSurveyItem[];
}

export class CommunityPost {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsUUID()
  @IsNotEmpty()
  community_id: string;

  @IsString()
  @IsNotEmpty()
  title: string;

  @IsUUID()
  @IsOptional()
  cover_attachment_id?: string;

  @IsIn(['summary', 'extended'])
  @IsString()
  @IsNotEmpty()
  content_type: 'summary' | 'extended';

  @IsString()
  @IsOptional()
  summary?: string;

  @ValidateNested()
  @Type(() => ContentItem)
  @IsOptional()
  content?: ContentItem;

  @IsNotEmpty()
  settings: CommunityPostSettings | CommunityPostAdminSettings;

  @IsString({ each: true })
  @IsArray()
  @IsNotEmpty()
  tags: string[];

  @ValidateNested()
  @Type(() => SocialUser)
  @IsOptional()
  author?: SocialUser;

  @IsDateString()
  @IsNotEmpty()
  created_at: string;

  @IsDateString()
  @IsOptional()
  published_at?: string;

  @ValidateNested()
  @Type(() => EntityReactions)
  @IsOptional()
  reactions?: EntityReactions;

  @IsInt()
  @IsOptional()
  comments_num?: number;

  @IsInt()
  @IsOptional()
  views_num?: number;

  @IsBoolean()
  @IsNotEmpty()
  pinned: boolean;

  @ValidateNested({ each: true })
  @Type(() => WidgetsInPost)
  @IsArray()
  @IsOptional()
  widgets?: WidgetsInPost[];

  @IsIn(['administrator', 'owner'])
  @IsString()
  @IsOptional()
  edited_by?: 'administrator' | 'owner';

  @ValidateNested()
  @Type(() => PostUserActions)
  @IsOptional()
  actions?: PostUserActions;

  @ValidateNested()
  @Type(() => PostModerationInfo)
  @IsOptional()
  moderation_info?: PostModerationInfo;

  @IsBoolean()
  @IsOptional()
  in_favorites?: boolean;
}

export class CommunitiesFeedResponse {
  @ValidateNested({ each: true })
  @Type(() => CommunityPost)
  @IsArray()
  @IsNotEmpty()
  posts: CommunityPost[];

  @ValidateNested({ each: true })
  @Type(() => CommunityInfo)
  @IsArray()
  @IsNotEmpty()
  communities: CommunityInfo[];

  @IsInt()
  @IsOptional()
  total?: number;

  @IsInt()
  @IsOptional()
  my_total_posts?: number;
}

export class CommunityTypeListResponse {
  @IsString({ each: true })
  @IsArray()
  @IsNotEmpty()
  types: string[];
}

export type CommunityCompaniesFilterOptionsResponse = FilterSelectOption[];

export type CommunityJoinRequestType = string;

export class CommunityJoinRequestTypeInfo {
  @IsIn(['incoming', 'outgoing'])
  @IsString()
  @IsNotEmpty()
  type: 'incoming' | 'outgoing';

  @IsInt()
  @IsNotEmpty()
  count: number;
}

export class CommunityCategoryWithCount {
  @IsIn(['Хобби и интересы', 'Флудилка', 'Мероприятия', 'База знаний'])
  @IsString()
  @IsNotEmpty()
  name: 'Хобби и интересы' | 'Флудилка' | 'Мероприятия' | 'База знаний';

  @IsInt()
  @IsNotEmpty()
  count: number;
}

export class CommunityList {
  @ValidateNested({ each: true })
  @Type(() => CommunityListItem)
  @IsArray()
  @IsNotEmpty()
  items: CommunityListItem[];

  @IsInt()
  @IsNotEmpty()
  total: number;
}

export class CommunityListResponse {
  @ValidateNested()
  @Type(() => CommunityList)
  @IsNotEmpty()
  communities: CommunityList;

  @IsInt()
  @IsNotEmpty()
  total_all: number;

  @IsInt()
  @IsNotEmpty()
  total_my_subscriptions: number;

  @IsInt()
  @IsNotEmpty()
  total_recently_visited: number;

  @IsInt()
  @IsNotEmpty()
  total_managed: number;

  @IsInt()
  @IsNotEmpty()
  total_join_requests: number;

  @ValidateNested({ each: true })
  @Type(() => CommunityCategoryWithCount)
  @IsArray()
  @IsOptional()
  categories?: CommunityCategoryWithCount[];

  @ValidateNested({ each: true })
  @Type(() => CommunityJoinRequestTypeInfo)
  @IsArray()
  @IsOptional()
  join_request_types?: CommunityJoinRequestTypeInfo[];
}

export class CreateCommunityJoinRequestResponse {
  @IsUUID()
  @IsNotEmpty()
  join_request_id: string;
}

export class CommunityMember {
  @ValidateNested()
  @Type(() => SocialUser)
  @IsNotEmpty()
  user: SocialUser;

  @IsIn(['owner', 'subscriber', 'admin', 'moderator', 'editor'])
  @IsString()
  @IsNotEmpty()
  role: 'owner' | 'subscriber' | 'admin' | 'moderator' | 'editor';
}

export class CommunityMembersResponse {
  @ValidateNested({ each: true })
  @Type(() => CommunityMember)
  @IsArray()
  @IsNotEmpty()
  members: CommunityMember[];
}

export class CommunityPostResponse {
  @ValidateNested()
  @Type(() => CommunityPost)
  @IsNotEmpty()
  post: CommunityPost;

  @ValidateNested()
  @Type(() => CommunityInfo)
  @IsNotEmpty()
  community: CommunityInfo;
}

export type AccountTagsFilterOptionsResponse = FilterSelectOption[];

export class CommunityFeedResponse {
  @ValidateNested({ each: true })
  @Type(() => CommunityPost)
  @IsArray()
  @IsNotEmpty()
  posts: CommunityPost[];

  @ValidateNested()
  @Type(() => CommunityInfo)
  @IsNotEmpty()
  community: CommunityInfo;

  @IsInt()
  @IsOptional()
  total?: number;

  @IsInt()
  @IsOptional()
  my_total?: number;

  @IsInt()
  @IsOptional()
  suggested_total?: number;

  @IsInt()
  @IsOptional()
  moderation_total?: number;
}

export class CommunityUserSetting {
  @IsBoolean()
  @IsNotEmpty()
  hide_post_in_feed: boolean;
}

export class UnitAccessScope {
  @IsUUID()
  @IsNotEmpty()
  unit_id: string;

  @IsIn(['operational', 'legal'])
  @IsString()
  @IsOptional()
  unit_type?: 'operational' | 'legal';
}

export class CommunityAccessScope {
  @IsUUID()
  @IsNotEmpty()
  company_id: string;

  @ValidateNested({ each: true })
  @Type(() => UnitAccessScope)
  @IsArray()
  @IsNotEmpty()
  units: UnitAccessScope[];
}

export class CommunitySettings {
  @IsBoolean()
  @IsNotEmpty()
  show_participants: boolean;

  @IsBoolean()
  @IsNotEmpty()
  allow_posts: boolean;

  @IsBoolean()
  @IsOptional()
  post_moderation?: boolean;

  @IsBoolean()
  @IsNotEmpty()
  comments_enabled: boolean;

  @IsBoolean()
  @IsNotEmpty()
  reactions_enabled: boolean;

  @ValidateNested({ each: true })
  @Type(() => CommunityAccessScope)
  @IsArray()
  @IsNotEmpty()
  access_scopes: CommunityAccessScope[];
}

export class Community {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @ValidateNested()
  @Type(() => AccountItem)
  @IsNotEmpty()
  account: AccountItem;

  @IsString()
  @IsNotEmpty()
  title: string;

  @IsString()
  @IsNotEmpty()
  slug: string;

  @IsUUID()
  @IsOptional()
  avatar_attachment_id?: string;

  @IsUUID()
  @IsOptional()
  header_attachment_id?: string;

  @IsIn(['public', 'private', 'hidden'])
  @IsString()
  @IsNotEmpty()
  community_type: 'public' | 'private' | 'hidden';

  @ValidateNested()
  @Type(() => SocialEntityCategory)
  @IsNotEmpty()
  category: SocialEntityCategory;

  @ValidateNested()
  @Type(() => BaseContentItem)
  @IsNotEmpty()
  description: BaseContentItem;

  @ValidateNested()
  @Type(() => CommunitySettings)
  @IsNotEmpty()
  settings: CommunitySettings;

  @ValidateNested()
  @Type(() => CommunityMembershipInfo)
  @IsNotEmpty()
  membership_info: CommunityMembershipInfo;

  @ValidateNested()
  @Type(() => CommunityUserSetting)
  @IsOptional()
  user_settings?: CommunityUserSetting;
}

export class CreateCommunityResponse {
  @IsUUID()
  @IsNotEmpty()
  id: string;
}

export type CommunityTagsFilterOptionsResponse = FilterSelectOption[];

export type CommunitiesFilterOptionsResponse = FilterSelectOption[];

export type CommunitiesUnitsOptionsResponse = FilterSelectOption[];

export class UnitTreeItem {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsBoolean()
  @IsNotEmpty()
  is_parent: boolean;

  @ValidateNested({ each: true })
  @Type(() => UnitTreeItem)
  @IsArray()
  @IsOptional()
  children?: UnitTreeItem[];
}

export class GetCommunitiesUnitChildrenResponse {
  @ValidateNested({ each: true })
  @Type(() => UnitTreeItem)
  @IsArray()
  @IsOptional()
  units?: UnitTreeItem[];
}

export class GetCommunitiesUnitsTreeResponse {
  @IsInt()
  @IsNotEmpty()
  total: number;

  @ValidateNested()
  @Type(() => UnitTreeItem)
  @IsOptional()
  root_unit?: UnitTreeItem;
}

export class UnitTypeItem {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsIn(['operational', 'legal'])
  @IsString()
  @IsNotEmpty()
  type: 'operational' | 'legal';
}

export class GetCommunitiesUnitTypesResponse {
  @ValidateNested({ each: true })
  @Type(() => UnitTypeItem)
  @IsArray()
  @IsNotEmpty()
  types: UnitTypeItem[];
}

export class CompanyAccessItem {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsBoolean()
  @IsNotEmpty()
  units_disabled: boolean;
}

export type CommunityCompanies = CompanyAccessItem[];

export class AccountAccessItem {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsBoolean()
  @IsNotEmpty()
  full_access: boolean;

  @IsBoolean()
  @IsOptional()
  scope_disabled?: boolean;

  @IsBoolean()
  @IsNotEmpty()
  target_audience_enabled: boolean;

  @ValidateNested({ each: true })
  @Type(() => CompanyItem)
  @IsArray()
  @IsOptional()
  companies?: CompanyItem[];
}

export type CommunityAccounts = AccountAccessItem[];

export class AutoInviteCommunitySettingsRequest {
  @IsIn(['all', 'custom', 'none'])
  @IsString()
  @IsNotEmpty()
  mode: 'all' | 'custom' | 'none';

  @IsIn(['auto_join', 'require_confirmation'])
  @IsString()
  @IsNotEmpty()
  join_mode: 'auto_join' | 'require_confirmation';

  @ValidateNested({ each: true })
  @Type(() => CompaniesGroup)
  @IsArray()
  @IsOptional()
  company_groups?: CompaniesGroup[];
}

export class RevokeCommunityMemberRoleRequest {
  @IsUUID()
  @IsNotEmpty()
  user_id: string;
}

export class AssignCommunityMemberRoleRequest {
  @IsUUID()
  @IsNotEmpty()
  user_id: string;

  @IsIn(['admin', 'moderator', 'editor'])
  @IsString()
  @IsNotEmpty()
  role: 'admin' | 'moderator' | 'editor';
}

export class CommunityParticipantsListRequestFilters {
  @IsString()
  @IsOptional()
  query?: string;

  @IsIn(['member', 'admin', 'invited', 'join_request'])
  @IsString()
  @IsNotEmpty()
  status: 'member' | 'admin' | 'invited' | 'join_request';

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  company_ids?: string[];

  @IsIn(['owner', 'subscriber', 'admin', 'moderator', 'editor'], { each: true })
  @IsString({ each: true })
  @IsArray()
  @IsOptional()
  roles?: ('owner' | 'subscriber' | 'admin' | 'moderator' | 'editor')[];
}

export class Pagination {
  @IsInt()
  @IsOptional()
  limit?: number;

  @IsInt()
  @IsOptional()
  offset?: number;
}

export class CommunityParticipantsListRequest {
  @ValidateNested()
  @Type(() => Pagination)
  @IsOptional()
  pagination?: Pagination;

  @ValidateNested()
  @Type(() => CommunityParticipantsListRequestFilters)
  @IsOptional()
  filters?: CommunityParticipantsListRequestFilters;
}

export class GetCommunityUserInvitersRequest {
  @IsUUID()
  @IsNotEmpty()
  user_id: string;
}

export class RemoveCommunityInvitesRequest {
  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsNotEmpty()
  user_ids: string[];
}

export class UserJoinGroup {
  @IsIn(['auto_join', 'require_confirmation'])
  @IsString()
  @IsNotEmpty()
  join_mode: 'auto_join' | 'require_confirmation';

  @IsUUID()
  @IsNotEmpty()
  company_id: string;

  @IsUUID()
  @IsOptional()
  unit?: string;

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  user_ids?: string[];
}

export class InviteUsersInCommunityRequest {
  @IsIn(['all', 'custom'])
  @IsString()
  @IsNotEmpty()
  mode: 'all' | 'custom';

  @IsIn(['auto_join', 'require_confirmation'])
  @IsString()
  @IsNotEmpty()
  join_mode: 'auto_join' | 'require_confirmation';

  @ValidateNested({ each: true })
  @Type(() => UserJoinGroup)
  @IsArray()
  @IsOptional()
  user_groups?: UserJoinGroup[];
}

export class CommunitiesFeedRequestFilters {
  @IsIn(['all', 'my'])
  @IsString()
  @IsOptional()
  authorship?: 'all' | 'my';

  @IsString()
  @IsOptional()
  text_search?: string;

  @IsString({ each: true })
  @IsArray()
  @IsOptional()
  tags_search?: string[];

  @IsString({ each: true })
  @IsArray()
  @IsOptional()
  category_titles?: string[];

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  company_ids?: string[];

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  community_ids?: string[];
}

export class CommunitiesFeedRequest {
  @ValidateNested()
  @Type(() => Pagination)
  @IsOptional()
  pagination?: Pagination;

  @ValidateNested()
  @Type(() => CommunitiesFeedRequestFilters)
  @IsOptional()
  filters?: CommunitiesFeedRequestFilters;
}

export class CommunityListRequestFilters {
  @IsIn([
    'all',
    'my_subscriptions',
    'recently_visited',
    'managed',
    'join_requests',
  ])
  @IsString()
  @IsOptional()
  status?:
    | 'all'
    | 'my_subscriptions'
    | 'recently_visited'
    | 'managed'
    | 'join_requests';

  @IsString()
  @IsOptional()
  text_search?: string;

  @IsString({ each: true })
  @IsArray()
  @IsOptional()
  category_titles?: string[];

  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  company_ids?: string[];

  @IsIn(['incoming', 'outgoing'])
  @IsString()
  @IsOptional()
  join_request_type?: 'incoming' | 'outgoing';
}

export class CommunityListRequest {
  @ValidateNested()
  @Type(() => Pagination)
  @IsOptional()
  pagination?: Pagination;

  @ValidateNested()
  @Type(() => CommunityListRequestFilters)
  @IsOptional()
  filters?: CommunityListRequestFilters;
}

export class RejectCommunityInvitesRequest {
  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsNotEmpty()
  user_ids: string[];
}

export class CommunityUserSettingsRequest {
  @IsBoolean()
  @IsNotEmpty()
  hide_post_in_feed: boolean;
}

export class RejectCommunityJoinRequestsRequest {
  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsNotEmpty()
  user_ids: string[];
}

export class AcceptCommunityJoinRequestsRequest {
  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsNotEmpty()
  user_ids: string[];
}

export class RemoveCommunityJoinRequestsRequest {
  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsNotEmpty()
  user_ids: string[];
}

export class UnsubscribeFromCommunityRequest {
  @IsUUID()
  @IsOptional()
  new_owner_id?: string;
}

export class AssignCommunityOwnerRequest {
  @IsUUID()
  @IsNotEmpty()
  user_id: string;
}

export class RemoveCommunityMembersRequest {
  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsNotEmpty()
  user_ids: string[];
}

export class CommunityPostRequest {
  @IsString()
  @IsNotEmpty()
  title: string;

  @IsUUID()
  @IsOptional()
  cover_attachment_id?: string;

  @IsIn(['summary', 'extended'])
  @IsString()
  @IsNotEmpty()
  content_type: 'summary' | 'extended';

  @IsString()
  @IsOptional()
  summary?: string;

  @ValidateNested()
  @Type(() => ContentItem)
  @IsOptional()
  content?: ContentItem;

  @IsNotEmpty()
  settings: CommunityPostSettings | CommunityPostAdminSettings;

  @IsString({ each: true })
  @IsArray()
  @IsNotEmpty()
  tags: string[];
}

export class ApproveSuggestedPostRequest {
  @ValidateNested()
  @Type(() => CommunityPostRequest)
  @IsOptional()
  post?: CommunityPostRequest;

  @IsBoolean()
  @IsNotEmpty()
  publish_by_creation_date: boolean;
}

export class DeclineSuggestedPostRequest {
  @IsString()
  @IsNotEmpty()
  comment: string;
}

export class CommunityFeedRequestFilters {
  @IsIn(['all', 'my', 'suggested', 'moderation'])
  @IsString()
  @IsOptional()
  feed_type?: 'all' | 'my' | 'suggested' | 'moderation';

  @IsString()
  @IsOptional()
  text_search?: string;

  @IsString({ each: true })
  @IsArray()
  @IsOptional()
  tags_search?: string[];
}

export class CommunityFeedRequest {
  @ValidateNested()
  @Type(() => Pagination)
  @IsOptional()
  pagination?: Pagination;

  @ValidateNested()
  @Type(() => CommunityFeedRequestFilters)
  @IsOptional()
  filters?: CommunityFeedRequestFilters;
}

export class UpdateCommunityRequest {
  @IsString()
  @IsNotEmpty()
  title: string;

  @IsString()
  @IsNotEmpty()
  slug: string;

  @IsUUID()
  @IsOptional()
  avatar_attachment_id?: string;

  @IsUUID()
  @IsOptional()
  header_attachment_id?: string;

  @IsIn(['public', 'private', 'hidden'])
  @IsString()
  @IsNotEmpty()
  community_type: 'public' | 'private' | 'hidden';

  @IsUUID()
  @IsNotEmpty()
  category_id: string;

  @ValidateNested()
  @Type(() => BaseContentItem)
  @IsNotEmpty()
  description: BaseContentItem;

  @ValidateNested()
  @Type(() => CommunitySettings)
  @IsNotEmpty()
  settings: CommunitySettings;
}

export class CreateCommunityRequest {
  @IsUUID()
  @IsNotEmpty()
  account_id: string;

  @IsString()
  @IsNotEmpty()
  title: string;

  @IsString()
  @IsNotEmpty()
  slug: string;

  @IsUUID()
  @IsOptional()
  avatar_attachment_id?: string;

  @IsUUID()
  @IsOptional()
  header_attachment_id?: string;

  @IsIn(['public', 'private', 'hidden'])
  @IsString()
  @IsNotEmpty()
  community_type: 'public' | 'private' | 'hidden';

  @IsUUID()
  @IsNotEmpty()
  category_id: string;

  @ValidateNested()
  @Type(() => BaseContentItem)
  @IsOptional()
  description?: BaseContentItem;

  @ValidateNested()
  @Type(() => CommunitySettings)
  @IsNotEmpty()
  settings: CommunitySettings;
}

@injectable()
export class CommunityService {
  constructor(
    private validator: ValidationService,
    private http: HttpService,
    private unmarshaller: UnmarshallerService,
    private query: QueryService,
  ) {}

  async communityCategoryTitlesFilterOptions({
    query = {},
  }: {
    query?: CommunityCategoryTitlesFilterOptionsQuery;
  } = {}) {
    await Promise.all([
      this.validator.validateOrReject(
        query,
        CommunityCategoryTitlesFilterOptionsQuery,
      ),
    ]);

    let requestPath = '/community/category_titles/filter_options';

    const result = await this.http.get(requestPath, query, {});

    class Response {
      @ValidateNested()
      @Type(() => FilterSelectOption)
      response: FilterSelectOption[];
    }
    const { response } = await this.unmarshaller.unmarshall(
      { response: result },
      Response,
    );

    return response;
  }

  async getAutoInviteSettings({
    params,
  }: {
    params: GetAutoInviteSettingsParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, GetAutoInviteSettingsParams),
    ]);

    let requestPath = '/community/{community_id}/auto-invite/settings';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetAutoInviteSettingsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      AutoInviteCommunitySettingsResponse,
    );

    return response;
  }

  async configureAutoInviteSettings({
    params,
    body,
  }: {
    params: ConfigureAutoInviteSettingsParams;
    body: AutoInviteCommunitySettingsRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        params,
        ConfigureAutoInviteSettingsParams,
      ),
      this.validator.validateOrReject(body, AutoInviteCommunitySettingsRequest),
    ]);

    let requestPath = '/community/{community_id}/auto-invite/settings';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof ConfigureAutoInviteSettingsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.put(requestPath, body, {});

    return result;
  }

  async revokeCommunityMemberRole({
    params,
    body,
  }: {
    params: RevokeCommunityMemberRoleParams;
    body: RevokeCommunityMemberRoleRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, RevokeCommunityMemberRoleParams),
      this.validator.validateOrReject(body, RevokeCommunityMemberRoleRequest),
    ]);

    let requestPath = '/community/{community_id}/members/role';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof RevokeCommunityMemberRoleParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.delete(requestPath, body, {});

    return result;
  }

  async setCommunityMemberRole({
    params,
    body,
  }: {
    params: SetCommunityMemberRoleParams;
    body: AssignCommunityMemberRoleRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, SetCommunityMemberRoleParams),
      this.validator.validateOrReject(body, AssignCommunityMemberRoleRequest),
    ]);

    let requestPath = '/community/{community_id}/members/role';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof SetCommunityMemberRoleParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, body, {});

    return result;
  }

  async getCommunityAssignableRoles() {
    let requestPath = '/community/assignable_roles';

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      CommunityAssignableRolesResponse,
    );

    return response;
  }

  async getCommunityParticipantsRoles({
    query = {},
  }: {
    query?: GetCommunityParticipantsRolesQuery;
  } = {}) {
    await Promise.all([
      this.validator.validateOrReject(
        query,
        GetCommunityParticipantsRolesQuery,
      ),
    ]);

    let requestPath = '/community/participants/roles/filter_options';

    const result = await this.http.get(requestPath, query, {});

    class Response {
      @ValidateNested()
      @Type(() => FilterSelectOption)
      response: FilterSelectOption[];
    }
    const { response } = await this.unmarshaller.unmarshall(
      { response: result },
      Response,
    );

    return response;
  }

  async getCommunityParticipantsListingAvailableFilters({
    params,
  }: {
    params: getCommunityParticipantsListingAvailableFiltersParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        params,
        getCommunityParticipantsListingAvailableFiltersParams,
      ),
    ]);

    let requestPath =
      '/community/{community_id}/participants/listing/available_filters';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof getCommunityParticipantsListingAvailableFiltersParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      FiltersResponse,
    );

    return response;
  }

  async getCommunityParticipantsEditAvailableFilters({
    params,
  }: {
    params: getCommunityParticipantsEditAvailableFiltersParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        params,
        getCommunityParticipantsEditAvailableFiltersParams,
      ),
    ]);

    let requestPath =
      '/community/{community_id}/participants/edit/available_filters';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof getCommunityParticipantsEditAvailableFiltersParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      FiltersResponse,
    );

    return response;
  }

  async getCommunityParticipants({
    params,
    body = {},
  }: {
    params: getCommunityParticipantsParams;
    body?: CommunityParticipantsListRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, getCommunityParticipantsParams),
      this.validator.validateOrReject(body, CommunityParticipantsListRequest),
    ]);

    let requestPath = '/community/{community_id}/participants';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof getCommunityParticipantsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, body, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      CommunityParticipantsResponse,
    );

    return response;
  }

  async allCompaniesInCommunity({
    params,
  }: {
    params: AllCompaniesInCommunityParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, AllCompaniesInCommunityParams),
    ]);

    let requestPath = '/community/{community_id}/companies';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof AllCompaniesInCommunityParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      AllCompaniesInCommunityResponse,
    );

    return response;
  }

  async getCommunityUserInviters({
    params,
    body,
  }: {
    params: getCommunityUserInvitersParams;
    body: GetCommunityUserInvitersRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, getCommunityUserInvitersParams),
      this.validator.validateOrReject(body, GetCommunityUserInvitersRequest),
    ]);

    let requestPath = '/community/{community_id}/users/inviters';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof getCommunityUserInvitersParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, body, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      CommunityUserInvitersResponse,
    );

    return response;
  }

  async getCommunityInviteStatus({
    query,
    params,
  }: {
    query: GetCommunityInviteStatusQuery;
    params: GetCommunityInviteStatusParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, GetCommunityInviteStatusQuery),
      this.validator.validateOrReject(params, GetCommunityInviteStatusParams),
    ]);

    let requestPath = '/community/{community_id}/invite/status';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetCommunityInviteStatusParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      InviteUsersStatusInCommunityResponse,
    );

    return response;
  }

  async removeCommunityInvites({
    params,
    body,
  }: {
    params: RemoveCommunityInvitesParams;
    body: RemoveCommunityInvitesRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, RemoveCommunityInvitesParams),
      this.validator.validateOrReject(body, RemoveCommunityInvitesRequest),
    ]);

    let requestPath = '/community/{community_id}/invite';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof RemoveCommunityInvitesParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.delete(requestPath, body, {});

    return result;
  }

  async inviteUsersInCommunity({
    params,
    body,
  }: {
    params: InviteUsersInCommunityParams;
    body: InviteUsersInCommunityRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, InviteUsersInCommunityParams),
      this.validator.validateOrReject(body, InviteUsersInCommunityRequest),
    ]);

    let requestPath = '/community/{community_id}/invite';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof InviteUsersInCommunityParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, body, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      InviteUsersInCommunityResponse,
    );

    return response;
  }

  async getAvailableUsersForCommunity({
    query = {},
    params,
  }: {
    query?: getAvailableUsersForCommunityQuery;
    params: getAvailableUsersForCommunityParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        query,
        getAvailableUsersForCommunityQuery,
      ),
      this.validator.validateOrReject(
        params,
        getAvailableUsersForCommunityParams,
      ),
    ]);

    let requestPath = '/community/{community_id}/users/available';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof getAvailableUsersForCommunityParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      CommunityAvailableUsersToInviteResponse,
    );

    return response;
  }

  async getUserCommunityPermissions({
    params,
  }: {
    params: getUserCommunityPermissionsParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        params,
        getUserCommunityPermissionsParams,
      ),
    ]);

    let requestPath = '/community/{community_id}/permission';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof getUserCommunityPermissionsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      CommunityUserPermissionsResponse,
    );

    return response;
  }

  async getCommunitiesRecommendations({
    query = {},
  }: {
    query?: GetCommunitiesRecommendationsQuery;
  } = {}) {
    await Promise.all([
      this.validator.validateOrReject(
        query,
        GetCommunitiesRecommendationsQuery,
      ),
    ]);

    let requestPath = '/communities/recommendation';

    const result = await this.http.get(requestPath, query, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      CommunitiesShortListResponse,
    );

    return response;
  }

  async getCommunitiesSubscriptions({
    query = {},
  }: {
    query?: GetCommunitiesSubscriptionsQuery;
  } = {}) {
    await Promise.all([
      this.validator.validateOrReject(query, GetCommunitiesSubscriptionsQuery),
    ]);

    let requestPath = '/communities/subscriptions';

    const result = await this.http.get(requestPath, query, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      CommunitiesShortListResponse,
    );

    return response;
  }

  async getAvailableCommunitiesFeedFilters() {
    let requestPath = '/communities/feed/available_filters';

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      FiltersResponse,
    );

    return response;
  }

  async getCommunitiesFeed({
    body = {},
  }: {
    body?: CommunitiesFeedRequest;
  } = {}) {
    await Promise.all([
      this.validator.validateOrReject(body, CommunitiesFeedRequest),
    ]);

    let requestPath = '/communities/feed';

    const result = await this.http.post(requestPath, body, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      CommunitiesFeedResponse,
    );

    return response;
  }

  async listCommunityTypes() {
    let requestPath = '/community/types';

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      CommunityTypeListResponse,
    );

    return response;
  }

  async getCommunityCompaniesFilterOptionsByScope({
    query = {},
    params,
  }: {
    query?: GetCommunityCompaniesFilterOptionsByScopeQuery;
    params: GetCommunityCompaniesFilterOptionsByScopeParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        query,
        GetCommunityCompaniesFilterOptionsByScopeQuery,
      ),
      this.validator.validateOrReject(
        params,
        GetCommunityCompaniesFilterOptionsByScopeParams,
      ),
    ]);

    let requestPath = '/community/{community_id}/companies/filter_options';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetCommunityCompaniesFilterOptionsByScopeParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    class Response {
      @ValidateNested()
      @Type(() => FilterSelectOption)
      response: FilterSelectOption[];
    }
    const { response } = await this.unmarshaller.unmarshall(
      { response: result },
      Response,
    );

    return response;
  }

  async getCommunityCompaniesFilterOptions({
    query = {},
  }: {
    query?: GetCommunityCompaniesFilterOptionsQuery;
  } = {}) {
    await Promise.all([
      this.validator.validateOrReject(
        query,
        GetCommunityCompaniesFilterOptionsQuery,
      ),
    ]);

    let requestPath = '/community/companies/filter_options';

    const result = await this.http.get(requestPath, query, {});

    class Response {
      @ValidateNested()
      @Type(() => FilterSelectOption)
      response: FilterSelectOption[];
    }
    const { response } = await this.unmarshaller.unmarshall(
      { response: result },
      Response,
    );

    return response;
  }

  async getCommunityList({
    body = {},
  }: {
    body?: CommunityListRequest;
  } = {}) {
    await Promise.all([
      this.validator.validateOrReject(body, CommunityListRequest),
    ]);

    let requestPath = '/community/list';

    const result = await this.http.post(requestPath, body, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      CommunityListResponse,
    );

    return response;
  }

  async getAvailableCommunityFilters() {
    let requestPath = '/community/available_filters';

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      FiltersResponse,
    );

    return response;
  }

  async rejectCommunityInvites({
    params,
    body,
  }: {
    params: RejectCommunityInvitesParams;
    body: RejectCommunityInvitesRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, RejectCommunityInvitesParams),
      this.validator.validateOrReject(body, RejectCommunityInvitesRequest),
    ]);

    let requestPath = '/community/{community_id}/invites/reject';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof RejectCommunityInvitesParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, body, {});

    return result;
  }

  async communityUserSettings({
    params,
    body,
  }: {
    params: CommunityUserSettingsParams;
    body: CommunityUserSettingsRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, CommunityUserSettingsParams),
      this.validator.validateOrReject(body, CommunityUserSettingsRequest),
    ]);

    let requestPath = '/community/{community_id}/user/settings';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof CommunityUserSettingsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, body, {});

    return result;
  }

  async rejectCommunityInvite({
    params,
  }: {
    params: RejectCommunityInviteParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, RejectCommunityInviteParams),
    ]);

    let requestPath = '/community/{community_id}/invites/{invite_id}/reject';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof RejectCommunityInviteParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, {}, {});

    return result;
  }

  async acceptCommunityInvite({
    params,
  }: {
    params: AcceptCommunityInviteParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, AcceptCommunityInviteParams),
    ]);

    let requestPath = '/community/{community_id}/invites/{invite_id}/accept';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof AcceptCommunityInviteParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, {}, {});

    return result;
  }

  async rejectCommunityJoinRequests({
    params,
    body,
  }: {
    params: RejectCommunityJoinRequestsParams;
    body: RejectCommunityJoinRequestsRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        params,
        RejectCommunityJoinRequestsParams,
      ),
      this.validator.validateOrReject(body, RejectCommunityJoinRequestsRequest),
    ]);

    let requestPath = '/community/{community_id}/join_requests/reject';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof RejectCommunityJoinRequestsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, body, {});

    return result;
  }

  async cancelCommunityJoinRequest({
    params,
  }: {
    params: CancelCommunityJoinRequestParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, CancelCommunityJoinRequestParams),
    ]);

    let requestPath =
      '/community/{community_id}/join_request/{join_request_id}';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof CancelCommunityJoinRequestParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.delete(requestPath, {}, {});

    return result;
  }

  async acceptCommunityJoinRequests({
    params,
    body,
  }: {
    params: AcceptCommunityJoinRequestsParams;
    body: AcceptCommunityJoinRequestsRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        params,
        AcceptCommunityJoinRequestsParams,
      ),
      this.validator.validateOrReject(body, AcceptCommunityJoinRequestsRequest),
    ]);

    let requestPath = '/community/{community_id}/join_requests/accept';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof AcceptCommunityJoinRequestsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, body, {});

    return result;
  }

  async removeCommunityJoinRequests({
    params,
    body,
  }: {
    params: RemoveCommunityJoinRequestsParams;
    body: RemoveCommunityJoinRequestsRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        params,
        RemoveCommunityJoinRequestsParams,
      ),
      this.validator.validateOrReject(body, RemoveCommunityJoinRequestsRequest),
    ]);

    let requestPath = '/community/{community_id}/join_request';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof RemoveCommunityJoinRequestsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.delete(requestPath, body, {});

    return result;
  }

  async createCommunityJoinRequest({
    params,
  }: {
    params: CreateCommunityJoinRequestParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, CreateCommunityJoinRequestParams),
    ]);

    let requestPath = '/community/{community_id}/join_request';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof CreateCommunityJoinRequestParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      CreateCommunityJoinRequestResponse,
    );

    return response;
  }

  async unsubscribeFromCommunity({
    params,
    body = {},
  }: {
    params: UnsubscribeFromCommunityParams;
    body?: UnsubscribeFromCommunityRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, UnsubscribeFromCommunityParams),
      this.validator.validateOrReject(body, UnsubscribeFromCommunityRequest),
    ]);

    let requestPath = '/community/{community_id}/subscribe';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof UnsubscribeFromCommunityParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.delete(requestPath, body, {});

    return result;
  }

  async subscribeToCommunity({
    params,
  }: {
    params: SubscribeToCommunityParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, SubscribeToCommunityParams),
    ]);

    let requestPath = '/community/{community_id}/subscribe';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof SubscribeToCommunityParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, {}, {});

    return result;
  }

  async assignCommunityOwner({
    params,
    body,
  }: {
    params: AssignCommunityOwnerParams;
    body: AssignCommunityOwnerRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, AssignCommunityOwnerParams),
      this.validator.validateOrReject(body, AssignCommunityOwnerRequest),
    ]);

    let requestPath = '/community/{community_id}/owner';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof AssignCommunityOwnerParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.put(requestPath, body, {});

    return result;
  }

  async removeCommunityMembers({
    params,
    body,
  }: {
    params: RemoveCommunityMembersParams;
    body: RemoveCommunityMembersRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, RemoveCommunityMembersParams),
      this.validator.validateOrReject(body, RemoveCommunityMembersRequest),
    ]);

    let requestPath = '/community/{community_id}/members';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof RemoveCommunityMembersParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.delete(requestPath, body, {});

    return result;
  }

  async getCommunityMembers({
    query = {},
    params,
  }: {
    query?: GetCommunityMembersQuery;
    params: GetCommunityMembersParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, GetCommunityMembersQuery),
      this.validator.validateOrReject(params, GetCommunityMembersParams),
    ]);

    let requestPath = '/community/{community_id}/members';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetCommunityMembersParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      CommunityMembersResponse,
    );

    return response;
  }

  async approveSuggestedPost({
    params,
    body,
  }: {
    params: ApproveSuggestedPostParams;
    body: ApproveSuggestedPostRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, ApproveSuggestedPostParams),
      this.validator.validateOrReject(body, ApproveSuggestedPostRequest),
    ]);

    let requestPath = '/community/{community_id}/post/{post_id}/approve';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof ApproveSuggestedPostParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, body, {});

    return result;
  }

  async declineSuggestedPost({
    params,
    body,
  }: {
    params: DeclineSuggestedPostParams;
    body: DeclineSuggestedPostRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, DeclineSuggestedPostParams),
      this.validator.validateOrReject(body, DeclineSuggestedPostRequest),
    ]);

    let requestPath = '/community/{community_id}/post/{post_id}/decline';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof DeclineSuggestedPostParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, body, {});

    return result;
  }

  async unpinCommunityPost({ params }: { params: UnpinCommunityPostParams }) {
    await Promise.all([
      this.validator.validateOrReject(params, UnpinCommunityPostParams),
    ]);

    let requestPath = '/community/{community_id}/post/{post_id}/pin';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof UnpinCommunityPostParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.delete(requestPath, {}, {});

    return result;
  }

  async pinCommunityPost({ params }: { params: PinCommunityPostParams }) {
    await Promise.all([
      this.validator.validateOrReject(params, PinCommunityPostParams),
    ]);

    let requestPath = '/community/{community_id}/post/{post_id}/pin';

    const paramsKeys = Object.keys(params) as (keyof PinCommunityPostParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, {}, {});

    return result;
  }

  async deleteCommunityPost({ params }: { params: DeleteCommunityPostParams }) {
    await Promise.all([
      this.validator.validateOrReject(params, DeleteCommunityPostParams),
    ]);

    let requestPath = '/community/{community_id}/post/{post_id}';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof DeleteCommunityPostParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.delete(requestPath, {}, {});

    return result;
  }

  async updateCommunityPost({
    params,
    body,
  }: {
    params: UpdateCommunityPostParams;
    body: CommunityPostRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, UpdateCommunityPostParams),
      this.validator.validateOrReject(body, CommunityPostRequest),
    ]);

    let requestPath = '/community/{community_id}/post/{post_id}';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof UpdateCommunityPostParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, body, {});

    return result;
  }

  async getCommunityPost({ params }: { params: GetCommunityPostParams }) {
    await Promise.all([
      this.validator.validateOrReject(params, GetCommunityPostParams),
    ]);

    let requestPath = '/community/{community_id}/post/{post_id}';

    const paramsKeys = Object.keys(params) as (keyof GetCommunityPostParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      CommunityPostResponse,
    );

    return response;
  }

  async getAccountTagsFilterOptions({
    query = {},
    params,
  }: {
    query?: GetAccountTagsFilterOptionsQuery;
    params: GetAccountTagsFilterOptionsParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, GetAccountTagsFilterOptionsQuery),
      this.validator.validateOrReject(
        params,
        GetAccountTagsFilterOptionsParams,
      ),
    ]);

    let requestPath = '/account/{account_id}/tags/filter_options';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetAccountTagsFilterOptionsParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    class Response {
      @ValidateNested()
      @Type(() => FilterSelectOption)
      response: FilterSelectOption[];
    }
    const { response } = await this.unmarshaller.unmarshall(
      { response: result },
      Response,
    );

    return response;
  }

  async suggestCommunityPost({
    params,
    body,
  }: {
    params: SuggestCommunityPostParams;
    body: CommunityPostRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, SuggestCommunityPostParams),
      this.validator.validateOrReject(body, CommunityPostRequest),
    ]);

    let requestPath = '/community/{community_id}/post/suggest';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof SuggestCommunityPostParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, body, {});

    return result;
  }

  async createCommunityPost({
    params,
    body,
  }: {
    params: CreateCommunityPostParams;
    body: CommunityPostRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, CreateCommunityPostParams),
      this.validator.validateOrReject(body, CommunityPostRequest),
    ]);

    let requestPath = '/community/{community_id}/post';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof CreateCommunityPostParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, body, {});

    return result;
  }

  async getCommunityFeed({
    params,
    body = {},
  }: {
    params: GetCommunityFeedParams;
    body?: CommunityFeedRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, GetCommunityFeedParams),
      this.validator.validateOrReject(body, CommunityFeedRequest),
    ]);

    let requestPath = '/community/{community_id}/feed';

    const paramsKeys = Object.keys(params) as (keyof GetCommunityFeedParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, body, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      CommunityFeedResponse,
    );

    return response;
  }

  async getAvailableCommunityFeedFilters() {
    let requestPath = '/community/{community_id}/feed/available_filters';

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      FiltersResponse,
    );

    return response;
  }

  async deleteCommunity({ params }: { params: DeleteCommunityParams }) {
    await Promise.all([
      this.validator.validateOrReject(params, DeleteCommunityParams),
    ]);

    let requestPath = '/community/{community_id}';

    const paramsKeys = Object.keys(params) as (keyof DeleteCommunityParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.delete(requestPath, {}, {});

    return result;
  }

  async updateCommunity({
    params,
    body,
  }: {
    params: UpdateCommunityParams;
    body: UpdateCommunityRequest;
  }) {
    await Promise.all([
      this.validator.validateOrReject(params, UpdateCommunityParams),
      this.validator.validateOrReject(body, UpdateCommunityRequest),
    ]);

    let requestPath = '/community/{community_id}';

    const paramsKeys = Object.keys(params) as (keyof UpdateCommunityParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, body, {});

    return result;
  }

  async getCommunity({ params }: { params: GetCommunityParams }) {
    await Promise.all([
      this.validator.validateOrReject(params, GetCommunityParams),
    ]);

    let requestPath = '/community/{community_id}';

    const paramsKeys = Object.keys(params) as (keyof GetCommunityParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, {}, {});

    const response = await this.unmarshaller.unmarshall(result, Community);

    return response;
  }

  async createCommunity({ body }: { body: CreateCommunityRequest }) {
    await Promise.all([
      this.validator.validateOrReject(body, CreateCommunityRequest),
    ]);

    let requestPath = '/community';

    const result = await this.http.post(requestPath, body, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      CreateCommunityResponse,
    );

    return response;
  }

  async markPostAsRead({ params }: { params: MarkPostAsReadParams }) {
    await Promise.all([
      this.validator.validateOrReject(params, MarkPostAsReadParams),
    ]);

    let requestPath = '/community/{community_id}/post/{post_id}/mark_read';

    const paramsKeys = Object.keys(params) as (keyof MarkPostAsReadParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.post(requestPath, {}, {});

    return result;
  }

  async getCommunitiesTagsFilterOptions({
    query = {},
  }: {
    query?: GetCommunitiesTagsFilterOptionsQuery;
  } = {}) {
    await Promise.all([
      this.validator.validateOrReject(
        query,
        GetCommunitiesTagsFilterOptionsQuery,
      ),
    ]);

    let requestPath = '/community/tags/filter_options';

    const result = await this.http.get(requestPath, query, {});

    class Response {
      @ValidateNested()
      @Type(() => FilterSelectOption)
      response: FilterSelectOption[];
    }
    const { response } = await this.unmarshaller.unmarshall(
      { response: result },
      Response,
    );

    return response;
  }

  async getCommunitiesFilterOptions({
    query = {},
  }: {
    query?: GetCommunitiesFilterOptionsQuery;
  } = {}) {
    await Promise.all([
      this.validator.validateOrReject(query, GetCommunitiesFilterOptionsQuery),
    ]);

    let requestPath = '/communities/filter_options';

    const result = await this.http.get(requestPath, query, {});

    class Response {
      @ValidateNested()
      @Type(() => FilterSelectOption)
      response: FilterSelectOption[];
    }
    const { response } = await this.unmarshaller.unmarshall(
      { response: result },
      Response,
    );

    return response;
  }

  async getUnitsOptions({
    query = {},
  }: {
    query?: GetUnitsOptionsQuery;
  } = {}) {
    await Promise.all([
      this.validator.validateOrReject(query, GetUnitsOptionsQuery),
    ]);

    let requestPath = '/communities/units/options';

    const result = await this.http.get(requestPath, query, {});

    class Response {
      @ValidateNested()
      @Type(() => FilterSelectOption)
      response: FilterSelectOption[];
    }
    const { response } = await this.unmarshaller.unmarshall(
      { response: result },
      Response,
    );

    return response;
  }

  async getCommunitiesUnitChildren({
    query = {},
    params,
  }: {
    query?: GetCommunitiesUnitChildrenQuery;
    params: GetCommunitiesUnitChildrenParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(query, GetCommunitiesUnitChildrenQuery),
      this.validator.validateOrReject(params, GetCommunitiesUnitChildrenParams),
    ]);

    let requestPath =
      '/communities/company/{company_id}/unit/{unit_id}/children';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetCommunitiesUnitChildrenParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetCommunitiesUnitChildrenResponse,
    );

    return response;
  }

  async getCommunitiesCompanyUnitsTree({
    query = {},
    params,
  }: {
    query?: GetCommunitiesCompanyUnitsTreeQuery;
    params: GetCommunitiesCompanyUnitsTreeParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        query,
        GetCommunitiesCompanyUnitsTreeQuery,
      ),
      this.validator.validateOrReject(
        params,
        GetCommunitiesCompanyUnitsTreeParams,
      ),
    ]);

    let requestPath = '/communities/company/{company_id}/unit/tree';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetCommunitiesCompanyUnitsTreeParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetCommunitiesUnitsTreeResponse,
    );

    return response;
  }

  async getCommunitiesCompanyUnitTypes({
    query = {},
    params,
  }: {
    query?: GetCommunitiesCompanyUnitTypesQuery;
    params: GetCommunitiesCompanyUnitTypesParams;
  }) {
    await Promise.all([
      this.validator.validateOrReject(
        query,
        GetCommunitiesCompanyUnitTypesQuery,
      ),
      this.validator.validateOrReject(
        params,
        GetCommunitiesCompanyUnitTypesParams,
      ),
    ]);

    let requestPath = '/communities/company/{company_id}/unit/types';

    const paramsKeys = Object.keys(
      params,
    ) as (keyof GetCommunitiesCompanyUnitTypesParams)[];
    if (paramsKeys.length) {
      paramsKeys.forEach((param) => {
        requestPath = requestPath.replace(
          `{${param}}`,
          encodeURIComponent(String(params[param])),
        );
      });
    }

    const result = await this.http.get(requestPath, query, {});

    const response = await this.unmarshaller.unmarshall(
      result,
      GetCommunitiesUnitTypesResponse,
    );

    return response;
  }

  async getCommunityCompanies({
    query = {},
  }: {
    query?: GetCommunityCompaniesQuery;
  } = {}) {
    await Promise.all([
      this.validator.validateOrReject(query, GetCommunityCompaniesQuery),
    ]);

    let requestPath = '/community/companies';

    const result = await this.http.get(requestPath, query, {});

    class Response {
      @ValidateNested()
      @Type(() => CompanyAccessItem)
      response: CompanyAccessItem[];
    }
    const { response } = await this.unmarshaller.unmarshall(
      { response: result },
      Response,
    );

    return response;
  }

  async getCommunityAccounts({
    query = {},
  }: {
    query?: GetCommunityAccountsQuery;
  } = {}) {
    await Promise.all([
      this.validator.validateOrReject(query, GetCommunityAccountsQuery),
    ]);

    let requestPath = '/community/accounts';

    const result = await this.http.get(requestPath, query, {});

    class Response {
      @ValidateNested()
      @Type(() => AccountAccessItem)
      response: AccountAccessItem[];
    }
    const { response } = await this.unmarshaller.unmarshall(
      { response: result },
      Response,
    );

    return response;
  }
}
